import { render, staticRenderFns } from "./AppSubHeader.vue?vue&type=template&id=0972aafe&scoped=true&"
import script from "./AppSubHeader.vue?vue&type=script&lang=js&"
export * from "./AppSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppSubHeader.vue?vue&type=style&index=0&id=0972aafe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0972aafe",
  null
  
)

export default component.exports